<template>
    <v-app id="searchAirbnbAipoBkmt">
      <v-main>
        <v-container v-show="showParameters" fluid>
         <v-row dense no-gutters> 
  
            <v-col cols="2" class="mx-2">
              <v-menu
                v-model="fromDatemenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
              <template v-slot:activator="{ on }">
              <v-text-field
                v-model="param.fromDate" 
                label="Payout from date"
                clearable
                v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker v-model="param.fromDate2" :first-day-of-week="1" @input="param.fromDate = $moment(param.fromDate2).format('DD-MM-YYYY'); fromDatemenu = false"></v-date-picker>
              </v-menu>  
            </v-col>  
  
        </v-row>
  
        <v-row>
            <v-col cols="1">
              <v-btn class="primary ma-0" small @click="getHuov">Search</v-btn>
            </v-col> 
        </v-row>
  
        </v-container>
  
        <v-container fluid>
         <v-btn v-show="!showParameters" class="primary ma-0" small @click="showParameters = true">Show parameters</v-btn> 
  
        <v-row v-if="results" dense no-gutters>
          <v-card class="px-2">
              <v-text-field
              v-model="search"
                label="Search"
                single-line
                hide-details
               >
              </v-text-field>
          
              <v-data-table 
              :items="items" 
              :items-per-page="50" 
              :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
              :headers="headers"
              :search="search"   
             
              >
              <template v-slot:item="props">
                <tr>
                <td>{{props.item.aipo_date}}</td>
                <td>{{props.item.aipo_payout_id}}</td>
                <td align="right">{{props.item.aipo_paid_out_amount}}</td>
                <td>{{props.item.bkmt_bookDate}}</td>
                <td>{{props.item.bkmt_description}}</td>
                <td align="right">{{props.item.bkmt_amount}}</td>
                <td align="right">{{props.item.amount_diff}}</td>
                </tr>
              </template>
              </v-data-table>
          </v-card>
          </v-row>
      </v-container>
      </v-main>
      <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
    </v-app>
  </template>
  
  <script>
  import navBar from "@/components/ui/navbars/navbar.vue";
   export default {
    components: {
      navBar
    },
    data() {
      return {
        results: false,
        showParameters: true,
        items: [],
        param: {},
        fromDatemenu: false,
  
        search: '',
        headers: [
          {text: 'Payout date', value: 'aipo_date'},
          {text: 'Payout ID', value: 'aipo_payout_id'},
          {text: 'Payout Amount', value: 'aipo_paid_out_amount'},
          {text: 'ABN date', value: 'bkmt_bookDate'},
          {text: 'ABN Description', value: 'bkmt_description'},
          {text: 'ABN Amount', value: 'bkmt_amount'},
          {text: 'Amount Compare', value: 'amount_diff'},
        ]
      }  
    },
    created() {
        this.$axios
        .post("ares/json/ares/task/inpt/airbnb/getSearchAirbnbAipoBkmtParam.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getSearchAirbnbAipoBkmtParam"
          },
          getSearchAirbnbAipoBkmtParam: {}
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
             this.param = res.data.getSearchAirbnbAipoBkmtParam;
          }
        });
  
    },
    methods: {
      /*
      dateToDMY (dat) {
          return dat ? this.$moment(dat).format('DD-MM-YYYY') : ''
        },
       */ 
       getHuov() {
        this.results = true;
        this.showParameters = false;
        this.$axios
          .post("ares/json/ares/task/inpt/airbnb/searchAirbnbAipoBkmt.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "searchAirbnbAipoBkmt"
            },
            searchAirbnbAipoBkmt: {
              fromDate: this.param.fromDate
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.items = res.data.searchAirbnbAipoBkmt;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
  
  </script> 
  